import gql from "graphql-tag";

export const IconDetailPartsFragmentDoc = gql`
    fragment IconDetailParts on IconType {
        id
        title
        creator {
            name
            id
            username
            avatarUrl
            country
        }
        thumbnails {
            thumbnail84
            thumbnail200
        }
        slugWithId
    }
`;

export const PrepaidBalancePartsFragmentDoc = gql`
    fragment PrepaidBalanceParts on CurrentUserType {
        hasSubscription
        hasPrepaidBalance
        totalPrepaidBalanceAvailableCents
    }
`;
